export enum CMREventTypes {
	Generic = "Generic",
    None = "None"
}
